/**
 * Phân loại các dòng master tại màn phương án phần bổ - Chi đầu tư phát triển
 */
export default {
  // Nguồn
  Source: 1,
  // Dự án, Nhiệm vụ
  Mission: 2,
  // Lĩnh vực
  Kind: 3,
  // Chi đầu tư và hỗ trợ vốn
  Capital: 4,
  // Chi đầu tư phát triển khác
  Other: 5,
};
